
import { mapGetters, mapMutations } from 'vuex';
import vClickOutside from 'v-click-outside';
import EcomMenuBadges from '~/components/badges/EcomMenuBadges.vue';
export default {
    components: { EcomMenuBadges },
    directives: {
        clickOutside: vClickOutside.directive
    },
    computed: {
        ...mapGetters(['getMenu', 'showMenuMobile'])
    },
    data() {
        return {
            activeMenus: []
        };
    },
    methods: {
        ...mapMutations(['setMainMenu', 'setShowMenuMobile', 'setShowNavigationMobile']),
        clickOutsideMenuMobile(event) {
            if (event?.target?.classList?.contains('show') && this.getShowNavigationMobile) {
                this.setShowMenuMobile(false);
                this.setShowNavigationMobile(false);
            }
            //   let isParent = false;
            //   if (
            //       event.target.parentNode &&
            //       (['menuMobile','menuItemsMob'].includes(event.target.parentNode.id)  || event.target.parentNode.id === 'menuMobile')
            //   ) {
            //       isParent = true;
            //   }
            //   if (
            //       event.target.id !== 'bar-catalog' &&
            //       event.target.id !== 'bar-catalog-mobile' &&
            //       event.target.id !== 'showCatalog' &&
            //       event.target.id !== 'showCatalogLink' &&
            //       event.target.id !== 'menuMobile' &&
            //       event.target.id !== 'menuItemsMob' &&
            //       !isParent
            //   ) {
            //       this.setShowMenuMobile(false);
            //       this.setShowNavigationMobile(false);
            //   }
        },
        toggleShowMenu(category) {
            if (this.activeMenus.includes(category)) {
                this.activeMenus = this.activeMenus.filter(e => e !== category);
            } else {
                this.activeMenus.push(category);
            }
        }
    },
    async fetch() {
        let menu = await this.$axios.$get('general/menu_tree');
        if (menu.length) {
            this.setMainMenu(menu);
            // this.setActiveMenuItem(menu[0].id)
        }
    }
};
